<!-- 活动详情 -->
<template>
  <div class="activitydetail">
    <v-head :bg="'#272727'"></v-head>
    <div class="container" style="margin-top:60px;min-width:1200px;">
      <!-- logo-details -->
      <div class="sponsorDet-logohead">
        <div class="logohead-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/activity' }">活动</el-breadcrumb-item>
            <el-breadcrumb-item>{{ titlecast }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- 详情主体内容（图文） -->
      <div class="activity-tcon">
        <div class="activity-main-img" :style="'backgroundImage:url(' + yerImage + ')'"></div>
      </div>
      <!-- 详情介绍内容 -->
      <div class="activity-bcon">
        <div class="case-bcon">
          <div class="bcon-dateandmech">
            <!-- 组织机构 -->
            <div class="bcon-mech">
              <div class="mech-title">组织机构</div>
              <div class="mech-con">
                <div class="mech-item" v-for="(item,index) of organization_list" :key="index">
                  <span class="mech-item-title">{{ item.title }}</span>
                  <span class="mech-item-inner">{{ item.content.split(',')[0] }}</span>
                  <span
                    class="mech-item-inner"
                    v-if="item.content.split(',')[1]"
                  >{{ item.content.split(',')[1] }}</span>
                </div>
              </div>
            </div>
            <!-- 活动数据 -->
            <div class="bcon-mech">
              <div class="mech-title">活动数据</div>
              <div class="activityData-con">
                <div
                  class="activityData-item"
                  v-for="(item,index) of activityData_list"
                  :key="index"
                  :class="[{'activityData-01':index == 0},{'activityData-02':index == 1},{'activityData-03':index == 2}]"
                >
                  <span class="activityData-item-data">{{ item.content }}</span>
                  <span class="activityData-item-title">{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 赛事规则 -->
          <div class="bcon-rule">
            <div v-for="(item,index) of data_list" :key="index">
              <!-- 标题 -->
              <div class="rule-title" v-if="item.type == 1">{{ item.info }}</div>
              <!-- 内容 -->
              <div v-if="item.type == 2">
                <div class="rule-intro" v-html="returnText(item.info)"></div>
              </div>
              <!-- 图片 -->
              <div class="itemss-img" v-if="item.type == 3">
                <img :src="item.info" width="100%" alt />
              </div>
              <!-- 分割线 -->
              <div class="itemss-line" v-if="item.type == 5"></div>
            </div>
            <!-- 注释掉了...去text文本找 -->
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
// import img from '@/assets/img/bg-zz.png'
import {
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
export default {
  data () {
    return {
      // 标题参数
      titlecast: '',
      // 主图片参数
      yerImage: '',
      // 组织机构参数
      organization_list: [],
      // 活动数据参数
      activityData_list: [],
      // 详情list
      data_list: []
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-breadcrumb': Breadcrumb,
    'el-breadcrumb-item': BreadcrumbItem
  },
  created () {
    // this.data_list = this.list[0]
    this.init()
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  methods: {
    init () {
      if (this.$route.query.id !== '') {
        this.$http({
          method: 'post',
          url: '/sponsor_case/info',
          params: {
            caseId: this.$route.query.id
          }
        }).then(res => {
          if (res.code === 100) {
            this.titlecast = res.result.title || this.$route.query.title
            this.yerImage = res.result.img
            this.organization_list = res.result.enterpriseList
            this.activityData_list = res.result.activityList
            this.data_list = JSON.parse(res.result.content)
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      } else {
        this.data_list = []
      }
    },
    // 文字回车/n转换
    returnText (val) {
      let str1 = val.replace(/\n/g, '<br/>')
      return str1
    }
  }
}
</script>
<style lang="scss" src="../sponsor-det/sponsor-det-native.scss"></style>
<style lang="scss" scoped>
.activitydetail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .sponsorDet-logohead {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    margin-bottom: 15px;
    .logohead-bread {
      padding: 25px 0;
      border-bottom: 1px solid #eeeeee;
    }
  }
  .activity-tcon {
    height: 400px;
    width: 1200px;
    margin: 0 auto 30px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    .activity-main-img {
      width: 100%;
      height: 100%;
      // background-image: url("../../assets/img/activity_03.jpg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .activity-bcon {
    width: 100%;
    height: auto;
  }
  .case-bcon {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 35px;
    .bcon-dateandmech {
      width: 35%;
      height: auto;
      padding-right: 25px;
      box-sizing: border-box;
      .bcon-date {
        width: 100%;
        margin-bottom: 20px;
        padding: 25px;
        box-sizing: border-box;
        background-color: #ffffff;
        .bcon-date-t {
          padding-bottom: 25px;
          .date-title {
            font-size: 16px;
            font-weight: 700;
            padding: 5px 0 10px 0;
          }
          .date-intro {
            font-size: 12px;
            line-height: 28px;
          }
        }
        .bcon-date-t:last-child {
          padding-bottom: 0;
        }
      }
      .bcon-mech {
        width: 100%;
        margin-bottom: 20px;
        padding: 10px 25px 25px 25px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        .mech-title {
          font-size: 18px;
          font-weight: 700;
          padding: 25px 0;
          line-height: 26px;
          border-bottom: 1px solid #f2f2f2;
        }
        .mech-con {
          width: 100%;
          padding: 25px 0 10px 0;
          box-sizing: border-box;
          display: grid;
          grid-row-gap: 20px;
          grid-column-gap: 20px;
          grid-template-columns: 161px 161px;
          grid-template-rows: 160px 160px;
          .mech-item {
            padding-top: 30px;
            border: 1px solid #f2f2f2;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            .mech-item-title {
              width: 100%;
              font-size: 14px;
              color: #2178ec;
              line-height: 36px;
              font-weight: 700;
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .mech-item-inner {
              font-size: 12px;
              line-height: 28px;
              width: 100%;
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
        .activityData-con {
          height: 350px;
          width: 100%;
          padding: 25px 0 10px 0;
          box-sizing: border-box;
          position: relative;
          .activityData-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .activityData-item-data {
              font-size: 26px;
              font-weight: 700;
              font-family: "Bebas Neue";
              color: #2675e9;
              line-height: 36px;
            }
            .activityData-item-title {
              font-size: 14px;
              line-height: 20px;
            }
          }
          .activityData-01 {
            position: absolute;
            width: 120px;
            height: 120px;
            text-align: center;
            border-radius: 50%;
            box-shadow: 0 0px 3px 10px #eeeeee;
            top: 40px;
            right: 120px;
          }
          .activityData-02 {
            position: absolute;
            width: 90px;
            height: 90px;
            text-align: center;
            border-radius: 50%;
            box-shadow: 0 0px 3px 10px #eeeeee;
            top: 180px;
            left: 30px;
          }
          .activityData-03 {
            position: absolute;
            width: 110px;
            height: 110px;
            text-align: center;
            border-radius: 50%;
            box-shadow: 0 0px 3px 10px #eeeeee;
            top: 195px;
            right: 65px;
          }
        }
      }
    }
    .bcon-rule {
      flex: 1;
      height: auto;
      padding: 10px 25px 25px 25px;
      box-sizing: border-box;
      border: 1px solid #f2f2f2;
      .rule-title {
        font-size: 18px;
        line-height: 26px;
        font-weight: 700;
        padding: 25px 0 0 0;
      }
      .rule-intro {
        font-size: 12px;
        line-height: 24px;
        padding-top: 25px;
        .rule-intro-title {
          font-size: 12px;
          line-height: 24px;
          font-weight: 700;
          span {
            font-weight: 700;
          }
        }
        p {
          font-size: 12px;
          line-height: 24px;
        }
      }
      .itemss-img {
        padding-top: 25px;
        width: 100%;
        img {
          font-size: 1px;
        }
      }
      .itemss-line {
        padding-top: 25px;
        border-bottom: 1px solid #f2f2f2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activity/activitydetail.vue